// extracted by mini-css-extract-plugin
module.exports = {"pill":"ChartAveragePill_pill__333dF"};